<template>
    <v-card
            class="mx-auto"
            max-width="460"
            dark
            raised

            color="#2d3b47"
            min-height="744"
            style="background: #2d3b47 !important;"
    >

        <v-tabs-items style="background: #2d3b47 !important;" dark v-model="tab">
            <v-tab-item

            >
                <v-list style="background: #2d3b47 !important;" dark>
                    <v-list-item style="text-align: center;">
                        <v-spacer><h1>Senaste</h1></v-spacer>
                    </v-list-item>
                    <v-list-item
                            v-for="(donation, i) in latest"
                            :key="i"
                            style="margin:20px;"
                    >
                        <v-chip label
                                large
                                :color=colorMe(donation.AMOUNT_DONATED)
                                style="font-size:24px;"
                        >
                            <b>{{donation.SENDER_NAME}}</b>
                        </v-chip>
                        <v-spacer></v-spacer>
                        <v-chip large color="transparent" :ripple="false" style="font-size:24px;">{{donation.AMOUNT_DONATED}} kr</v-chip>
                    </v-list-item>
                </v-list>
            </v-tab-item>

            <v-tab-item

            >

            </v-tab-item>

            <v-tab-item

            >
                <v-list style="background: #2d3b47 !important;" dark>
                    <v-list-item style="text-align: center;">
                        <v-spacer><h1>Topp-listan</h1></v-spacer>
                    </v-list-item>
                    <v-list-item
                            v-for="(donation, i) in top"
                            :key="i"
                            style="margin:20px;"
                    >
                        <v-chip label large style="font-size:24px;"
                                :color=colorMe(donation.AMOUNT_DONATED)
                        >
                            <b>{{donation.SENDER_NAME}}</b>
                        </v-chip>
                        <v-spacer></v-spacer>
                        <v-chip style="font-size:24px;" large color="transparent" :ripple="false">{{donation.AMOUNT_DONATED}} kr</v-chip>
                    </v-list-item>
                </v-list>
            </v-tab-item>

        </v-tabs-items>


    </v-card>
</template>

<script>
    export default {
        name: "CharityLeaderboardComp",
        props:["event_name","leaderboard_type","tab"],
        data(){
            return{
                latest:[],
                top:[]
            }
        },
        methods:{
            getTopData(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/GG_top_donators';

                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        self.top=data.slice(0, 11);
                    }

                };
                http.send();

            },
            getLatestData(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/GG_latest_donations';

                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {


                    if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        self.latest=data.slice(0, 11);
                    }

                };
                http.send();

            },
            colorMe(amount){
                if(parseInt(amount)>499){
                    return "orange"
                }
                else if(parseInt(amount)>99){
                    return "purple"
                }
                else if(parseInt(amount)>49){
                    return "blue"
                }
                else if(parseInt(amount)>20){
                    return "green"
                }
                else{
                    return "gray"
                }

            }
        },
        mounted:function(){
            let self=this;
            this.getTopData();
            this.getLatestData();
            setInterval(function(){
                self.getTopData();
                self.getLatestData();
            },5000)



        }
    }
</script>

<style scoped>




</style>
